
import request from '@/axios'

export function priorityList () {
  return request({
    url: '/tasks/priority/list',
    method: 'GET'
  })
}
export function taskList (customer_id, queryParams, params = null) {
  return request({
    url: `/tasks/template/list/${customer_id}?attribute=${queryParams.attribute ? queryParams.attribute : ''}&direction=${queryParams.direction ? queryParams.direction : ''}&field_type=${queryParams.field_type ? queryParams.field_type : ''}&table_name=${queryParams.table_name ? queryParams.table_name : ''}&page=${queryParams.page}&limit=${queryParams.limit}`,
    method: 'POST',
    data: params
  })
}
export function livetaskList (customer_id, queryParams, filterData = null) {
  let url = `/tasks/list/${customer_id}?table_name=${queryParams.table_name ? queryParams.table_name : ''}&page=${queryParams.page}&limit=${queryParams.limit}`
  if (queryParams.attribute) {
    url = `/tasks/list/${customer_id}?attribute=${queryParams.attribute ? queryParams.attribute : ''}&direction=${queryParams.direction ? queryParams.direction : ''}&field_type=${queryParams.field_type ? queryParams.field_type : ''}&table_name=${queryParams.table_name ? queryParams.table_name : ''}&page=${queryParams.page}&limit=${queryParams.limit}`
  }
  return request({
    url,
    method: 'POST',
    data: filterData
  })
}
export function taskCreate (customer_id, query) {
  return request({
    url: `tasks/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskUpdate (customer_id, task_id, query) {
  return request({
    url: `tasks/update/${task_id}/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskDelete (customer_id, query) {
  return request({
    url: `tasks/delete/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskDeleteFromProject (query) {
  return request({
    url: 'projects/remove_task_from_project',
    method: 'POST',
    data: query
  })
}
export function taskTemplateDelete (customer_id, query) {
  return request({
    url: `tasks/delete/templates/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskTemplateUpdate (customer_id, task_id, query) {
  return request({
    url: `tasks/update/template/${customer_id}/${task_id}`,
    method: 'POST',
    data: query
  })
}
export function taskShow (customer_id, task_id) {
  return request({
    url: `tasks/show/${task_id}/${customer_id}`,
    method: 'GET'
  })
}

export function taskTemplateShow (customer_id, task_id) {
  return request({
    url: `tasks/show/templates/${customer_id}/${task_id}`,
    method: 'GET'
  })
}

export function fetchUserClient (user_type, customer_id, query, payload = null) {
  let url = ''
  if (Object.keys(query).length === 0) {
    url = `/users/fetch_user_list/${user_type}/${customer_id}`
  } else {
    url = `/users/fetch_user_list/${user_type}/${customer_id}?page=${query.page}`
  }
  return request({
    url,
    method: 'POST',
    data: payload
  })
}

export function unassociatedList (customer_id, queryParams = 1) {
  return request({
    url: `tasks/unassociated/list/${customer_id}?page=${queryParams}`,
    method: 'GET'
  })
}


export function projectCreate (customer_id, query) {
  return request({
    url: `projects/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function projectList (customer_id, queryParams, filterData = null) {
  return request({
    url: `projects/list/${customer_id}?attribute=${queryParams.attribute ? queryParams.attribute : ''}&direction=${queryParams.direction ? queryParams.direction : ''}&field_type=${queryParams.field_type ? queryParams.field_type : ''}&table_name=${queryParams.table_name ? queryParams.table_name : ''}&page=${queryParams.current_page}&limit=${queryParams.limit}`,
    method: 'POST',
    data: filterData
  })
}


export function projectShow (customer_id, project_id) {
  return request({
    url: `projects/show/${project_id}/${customer_id}`,
    method: 'GET'
  })
}


export function projectUpdate (customer_id, project_id, query) {
  return request({
    url: `projects/update/${customer_id}/${project_id}`,
    method: 'POST',
    data: query
  })
}

export function projectDelete (customer_id, project_id, query) {
  return request({
    url: `projects/delete/${customer_id}/${project_id}`,
    method: 'POST',
    data: query
  })
}

export function projectKanbanShow (customer_id, project_id) {
  return request({
    url: `projects/kanban/${project_id}/${customer_id}`,
    method: 'GET'
  })
}

export function taskStatusCheck (customer_id, project_id) {
  return request({
    url: `projects/check/status/${customer_id}/${project_id}`,
    method: 'GET'
  })
}
export function parentTask (customer_id, queryParams = 1) {
  return request({
    url: `tasks/parent/list/${customer_id}?page=${queryParams}`,
    method: 'GET'
  })
}

export function tagList (customer_id, queryParams = 1, query) {
  return request({
    url: `/tag/all/${customer_id}?page=${queryParams}`,
    method: 'POST',
    data: query
  })
}

export function createLog (task_id, customer_id, query) {
  return request({
    url: `tasks/logs/create/${task_id}/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function kanbanReorder (project_id, customer_id, payload) {
  return request({
    url: `projects/kanban/reorder/${project_id}/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
